import { DEFAULT_API_BASE } from '../../config/src'

export async function fetchJson<T>(
  path: string,
  init: RequestInit = {},
  apiBase: string = DEFAULT_API_BASE,
): Promise<T> {
  const response = await fetch(`${apiBase}${path}`, {
    credentials: 'include',
    ...init,
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Request failed' }))
    throw new Error(error.detail || `HTTP ${response.status}`)
  }

  if (response.status === 204) {
    return undefined as T
  }

  return response.json()
}
